// oxlint-disable complexity
import { Body, Heading } from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDatevAppForm } from '../../components/form/hooks';
import { useDatevAuthContext } from '../../lib/DatevAuthContext';
import { useStandortContext } from '../../lib/StandortContext';
import { type LoginFormInput } from './LoginFormSchema';
import { LoginInputs } from './LoginInputs';
import { lohnabrechnungsart } from './constants/lohnabrechnungsart';
import { loginFormOptions } from './loginFormOptions';

export function LoginForm() {
  const { t } = useTranslation();
  const { standort } = useStandortContext();
  const { setStatus } = useDatevAuthContext();
  const navigate = useNavigate();

  const lohnabrechnungseinstellungen = standort?.lohnabrechnungseinstellungen;

  const isDatevLohnart =
    lohnabrechnungseinstellungen?.lohnabrechnungsart ===
      lohnabrechnungsart.LODAS ||
    lohnabrechnungseinstellungen?.lohnabrechnungsart ===
      lohnabrechnungsart.LOGE;

  const defaultValues: LoginFormInput = isDatevLohnart
    ? {
        mandantennummer:
          standort?.lohnabrechnungseinstellungen.mandantennummer ?? '',
        beraternummer:
          standort?.lohnabrechnungseinstellungen.beraternummer ?? '',
        lohnabrechnungsart:
          standort?.lohnabrechnungseinstellungen.lohnabrechnungsart ===
            lohnabrechnungsart.LODAS ||
          standort?.lohnabrechnungseinstellungen.lohnabrechnungsart ===
            lohnabrechnungsart.LOGE
            ? standort?.lohnabrechnungseinstellungen.lohnabrechnungsart
            : lohnabrechnungsart.LODAS,
      }
    : {
        mandantennummer: '',
        beraternummer: '',
        lohnabrechnungsart: lohnabrechnungsart.LODAS,
      };

  const form = useDatevAppForm({
    ...loginFormOptions,
    defaultValues,
    onSubmit: () => {
      // TODO Login
      setStatus({
        authorized: true,
        expiresAt: dayjs().add(7, 'day').toISOString(),
        name: 'Datev Test',
        beraternummer: '455148',
        mandantennummer: '1',
      });
      navigate('/datev');
    },
  });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}>
      <form.AppForm>
        <div className="flex flex-col gap-6 w-96">
          <div className="flex flex-col gap-3">
            <Heading size={'lg'}>{t('domain.datev.login.title')}</Heading>
            <Body>{t('domain.datev.login.description')}</Body>
          </div>
          <LoginInputs form={form} />
          <form.SubmitButton
            buttonText={t('domain.datev.login.form.submit.label')}
          />
        </div>
      </form.AppForm>
    </form>
  );
}
